<template>
  <my-profile-menu-layout>
    <authentication-settings></authentication-settings>
  </my-profile-menu-layout>
</template>

<script>
  import MyProfileMenuLayout from "@/components/layout/MyProfileMenuLayout";
  import AuthenticationSettings from '@/components/myprofile/AuthenticationSettings.vue';
  import CurrentUserMixin from "@/mixins/CurrentUserMixin";

  export default {
    name: "ProfileAuthentication",
    mixins: [CurrentUserMixin],
    data() {
      return {
      }
    },
    mounted() {
      this.$store.commit('user/set_current_project_id', this.project_id)
    },
    methods: {
    },
    components: {
      MyProfileMenuLayout, AuthenticationSettings
    },
  }
</script>

<style scoped>

</style>